export const FETCH_COUNTRIES_REQUEST = "FETCH_COUNTRIES_REQUEST";

export const FETCH_COUNTRIES_SUCCESS = "FETCH_COUNTRIES_SUCCESS";

export const FETCH_COUNTRIES_FAILURE = "FETCH_COUNTRIES_FAILURE";
